import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { get_panel } from "./../../../../../../redux/services/getPanel/getPanel";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { notificationAlertErrorApi } from "../../../../../method/notificationAlertErrorApi/notificationAlertErrorApi";
import { useDispatch } from "react-redux";

const useStyles = makeStyles(() => ({
  wrapper: {
    position: 'relative',
  },
  gridTitle: {
    position: 'absolute',
    top: '-12px',
    right: '5%',
    padding: '0px 10px',
    backgroundColor: '#fff',
  },
  grid: {
    display: "flex",
    alignItems: "center",
  },
  card: {
    backgroundColor: "#FFFFFF",
    borderRadius: 4,
    padding: 12,
    border: "1px solid #C2C2C2",
    margin: "16px 5px",
    cursor: "pointer",
    minWidth: 169,
    "&.selected": {
      borderColor: "#000",
      backgroundColor: "#f0f0f0",
    },
  },
  tadbir: {
    marginLeft: 15,
  },
  text: {
    fontSize: 14,
  },
}));

const Index = ({ setTradingSystemId, tradingSystemId }) => {

  const classes = useStyles();
  let location = useLocation();
  let dispatch = useDispatch();

  const [panelItem, setPanelItem] = useState([]);
  const [loading, setLoading] = useState(false);


  const { national_id, token } = location.state?.state || location.state || {};

  useEffect(() => {
    if (token) {

      let payload = {
        data: {
          nationalCode: national_id,
        },
        headers: {
          token: token,
        }
      }
      setLoading(true)
      get_panel(payload)
        .then((res) => {
          if (res?.data?.data) {
            setPanelItem(res?.data?.data);

            const selectedItem = res?.data?.data.find((item) => item.isSelected);
            if (selectedItem) {
              setTradingSystemId(selectedItem.id);
            }

          }
        })
        .catch((error) => {
          notificationAlertErrorApi(error, dispatch)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [token]);

  const onChangeTradingSystemId = (tsId) => setTradingSystemId(tsId)


  return (
    <div className={classes.wrapper}>

      <div className={classes.grid}>
        {panelItem
          .map((item, index) => (

            <div
              className={`${classes.card} ${item.slug} ${tradingSystemId === item.id ? "selected" : ""
                }`}
              onClick={() => onChangeTradingSystemId(item.id)}
              key={index}
            >
              <p className={classes.text}>{item.name}</p>
              <p className={classes.text}>
                {item.supportOption
                  ? "معاملات اختیار (آپشن)"
                  : "نمادهای تبعی (بیمه سهم)"}
              </p>
            </div>

          ))}
        {
          (panelItem.length === 0 && loading) && (
            <div>
              <p>
                درحال بارگذاری...
              </p>
            </div>
          )
        }
        {
          (panelItem.length === 0 && !loading) && (
            <div>
              <p>
                دیتای یافت نشد
              </p>
            </div>
          )
        }
      </div>
    </div>
  );
};

export default Index;
